class SizeGuideDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#SizeGuideDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setSizeGuideIconAccessibility();
  }

  setSizeGuideIconAccessibility() {
    const sizeGuideTriggers = document.querySelectorAll('[data-size-guide-drawer-trigger]');

    sizeGuideTriggers.forEach(trigger => {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(trigger);
      });
      trigger.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(trigger);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // 애니메이션이 항상 트리거되도록 timeout 사용
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('SizeGuideDrawer');
        const focusElement = this.querySelector('.size-guide-drawer__inner') || this.querySelector('.size-guide-drawer__close');
        if (typeof trapFocus === 'function') {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('size-guide-drawer', SizeGuideDrawer);

// 전역 함수로 drawer 열기
window.openSizeGuideDrawer = function () {
  const drawer = document.querySelector('size-guide-drawer');
  if (drawer) {
    drawer.open();
  }
};

// 전역 함수로 drawer 닫기
window.closeSizeGuideDrawer = function () {
  const drawer = document.querySelector('size-guide-drawer');
  if (drawer) {
    drawer.close();
  }
};

const cmToInch = cm => (cm * 0.393701).toFixed(1);



const changeUnit = (unit, el) => {
  // active 클래스 초기화
  document.querySelectorAll('.unit-btn').forEach(btn => btn.classList.remove('active', 'underline'));
  el.classList.add('active', 'underline');

  // 데이터 변환
  document.querySelectorAll('[data-cm]').forEach(cell => {
    const cmValue = parseFloat(cell.dataset.cm);
    cell.textContent = unit === 'inch' ? cmToInch(cmValue) : cmValue;
  });


}

// document.addEventListener('DOMContentLoaded', () => {
//   const inchBtn = document.querySelector('.size-unit .unit-btn:nth-child(1)');
//   if (inchBtn) {
//     inchBtn.click();  // 자동 클릭
//   }
// });